import { useCampaignStore } from '@/stores';
import { useAuth } from '@/contexts/AuthContext';
import { useTogglePaywall } from '@/hooks/queries';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';

export function PaywallToggleCard() {
  const { user } = useAuth();
  const selectedCampaign = useCampaignStore((s) => s.selectedCampaign);
  const { mutate: toggle, isPending } = useTogglePaywall();

  if (!user?.isPlatformAdmin || !selectedCampaign) return null;

  const isPaywalled =
    selectedCampaign.subscriptionStatus === 'Unpaid' ||
    selectedCampaign.subscriptionStatus === 'Canceled';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Paywall</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">
              Status: {selectedCampaign.subscriptionStatus}
            </p>
          </div>
          <Switch
            checked={isPaywalled}
            onCheckedChange={(checked) => toggle(checked)}
            disabled={isPending}
          />
        </div>
      </CardContent>
    </Card>
  );
}
